var _path, _path2, _circle, _circle2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAgentTruckIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 2.5H9V9H1.5V2.5Z",
    stroke: "currentColor",
    strokeWidth: 1.275
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 5H11L12.5 6.5V9H9",
    stroke: "currentColor",
    strokeWidth: 1.275
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 3.75,
    cy: 10.25,
    r: 1.125,
    stroke: "currentColor",
    strokeWidth: 1.275
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 10.25,
    cy: 10.25,
    r: 1.125,
    stroke: "currentColor",
    strokeWidth: 1.275
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAgentTruckIcon);
export default __webpack_public_path__ + "static/media/agent-truck-icon.5204955f16c5ce6ca93ec99178291e10.svg";
export { ForwardRef as ReactComponent };